import BackButton from "../shared/BackButton";
import { Box, Paper, Typography } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { ReactNode } from "react";

interface ScheduleSectionCardProps {
  title: string;
  subtitle?: string;
  tertiary?: string;
  /** np. chip ze statusem pozycji (pod tertiary) */
  afterTertiary?: ReactNode;
  onBack: () => void;
  children?: ReactNode;
  /** Domyślnie padding sekcji treści; np. `{ px: 0, pt: 0 }` pod zakładki na pełną szerokość */
  contentSx?: SxProps<Theme>;
}

/**
 * Sekcja harmonogramu w stylu wyników końcowych (`FinalResultsTable`) — jeden Paper, nagłówek + treść.
 */
export default function ScheduleSectionCard({
  title,
  subtitle,
  tertiary,
  afterTertiary,
  onBack,
  children,
  contentSx = { p: { xs: 2, sm: 3 } },
}: ScheduleSectionCardProps) {
  return (
    <Paper>
      <Box
        sx={{
          p: { xs: 1.5, sm: 2 },
          borderBottom: children ? 1 : 0,
          borderColor: "divider",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="h6"
            component="div"
            sx={{ color: "primary.main", fontSize: { xs: "1rem", sm: "1.25rem" }, fontWeight: 600 }}
          >
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="subtitle2" component="div" color="text.secondary" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          ) : null}
          {tertiary ? (
            <Typography variant="body2" component="div" color="text.secondary" sx={{ mt: subtitle ? 0.25 : 0.5 }}>
              {tertiary}
            </Typography>
          ) : null}
          {afterTertiary ? (
            <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.75, alignItems: "center" }}>
              {afterTertiary}
            </Box>
          ) : null}
        </Box>
        <BackButton onClick={onBack} showTooltip={false} />
      </Box>
      {children ? <Box sx={contentSx}>{children}</Box> : null}
    </Paper>
  );
}
